(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2966],{

/***/ 54181:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ ShareholderPage; }
});

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/pages/Ir/Investor/Shareholder/Table.tsx




var tableData = [{
  date: '6/26（土）',
  title: null,
  color: 'holiday'
}, {
  date: '6/27（日）',
  title: null,
  color: 'holiday'
}, {
  date: '6/28（月）',
  title: "\u6A29\u5229\u4ED8\u58F2\u8CB7\n\u6700\u7D42\u65E5",
  color: 'darkest'
}, {
  date: '6/29（火）',
  title: '権利落ち日',
  color: 'darkest'
}, {
  date: '6/30（水）',
  title: '権利確定日（配当基準日）',
  color: 'secondary'
}];
var DateTable = function DateTable() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Dl, {
    children: tableData.map(function (_ref) {
      var date = _ref.date,
          title = _ref.title,
          color = _ref.color;
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(DescriptionGroup, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Dt, {
          color: color,
          children: date
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Dd, {
          children: title
        })]
      }, date);
    })
  });
};
var Dl = styled_components_browser_esm/* default.dl.withConfig */.ZP.dl.withConfig({
  displayName: "Table__Dl",
  componentId: "sc-p1ziwr-0"
})(["display:flex;@media screen and (max-width:1047px){flex-direction:column;border-bottom:1px solid ", ";border-left:1px solid ", ";}"], theme/* theme.colors.tableBorder */.r.colors.tableBorder, theme/* theme.colors.tableBorder */.r.colors.tableBorder);
var DescriptionGroup = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Table__DescriptionGroup",
  componentId: "sc-p1ziwr-1"
})(["flex:1;border-top:1px solid ", ";border-right:1px solid ", ";&:first-of-type{border-left:1px solid ", ";@media screen and (max-width:1047px){border-left:none;}}@media screen and (max-width:1047px){display:flex;}"], theme/* theme.colors.tableBorder */.r.colors.tableBorder, theme/* theme.colors.tableBorder */.r.colors.tableBorder, theme/* theme.colors.tableBorder */.r.colors.tableBorder);
var Dt = styled_components_browser_esm/* default.dt.withConfig */.ZP.dt.withConfig({
  displayName: "Table__Dt",
  componentId: "sc-p1ziwr-2"
})(["display:grid;place-content:center;padding:14px 14px 16px 14px;text-align:center;border-bottom:1px solid ", ";line-height:1.2;word-break:keep-all;background:", ";@media screen and (max-width:1047px){border-bottom:none;border-right:1px solid ", ";width:40%;}"], theme/* theme.colors.tableBorder */.r.colors.tableBorder, function (_ref2) {
  var color = _ref2.color;
  return color === 'primary' ? theme/* theme.colors.th.primary */.r.colors.th.primary : color === 'secondary' ? theme/* theme.colors.th.secondary */.r.colors.th.secondary : color === 'darkest' ? theme/* theme.colors.th.darkest */.r.colors.th.darkest : color === 'accentYellow' ? theme/* theme.colors.th.accentYellow */.r.colors.th.accentYellow : color === 'holiday' ? theme/* theme.colors.th.holiday */.r.colors.th.holiday : theme/* theme.colors.th.default */.r.colors.th["default"];
}, theme/* theme.colors.tableBorder */.r.colors.tableBorder);
var Dd = styled_components_browser_esm/* default.dd.withConfig */.ZP.dd.withConfig({
  displayName: "Table__Dd",
  componentId: "sc-p1ziwr-3"
})(["display:grid;place-content:center;text-align:center;padding:14px 14px 16px 14px;line-height:1.2;background:#ffffff;border-bottom:1px solid ", ";word-break:keep-all;height:4.3rem;white-space:pre-wrap;@media screen and (max-width:1047px){padding:10px 12px 12px 12px;font-size:13px;border-bottom:none;height:auto;width:60%;}"], theme/* theme.colors.tableBorder */.r.colors.tableBorder);
// EXTERNAL MODULE: ./src/components/elements/Line/index.tsx
var Line = __webpack_require__(9945);
// EXTERNAL MODULE: ./src/components/elements/SectionTitle/index.tsx
var SectionTitle = __webpack_require__(70770);
// EXTERNAL MODULE: ./src/components/elements/Spacer/index.tsx
var Spacer = __webpack_require__(1253);
// EXTERNAL MODULE: ./src/components/layout.tsx + 7 modules
var layout = __webpack_require__(55548);
// EXTERNAL MODULE: ./src/components/layouts/Head/index.tsx
var Head = __webpack_require__(22978);
// EXTERNAL MODULE: ./src/components/layouts/Ir/index.tsx
var Ir = __webpack_require__(87661);
// EXTERNAL MODULE: ./src/components/layouts/Ir/Heading.tsx
var Heading = __webpack_require__(82592);
// EXTERNAL MODULE: ./src/components/layouts/Ir/Paragraph.tsx
var Paragraph = __webpack_require__(45775);
;// CONCATENATED MODULE: ./src/components/pages/Ir/Investor/Shareholder/index.tsx














var ShareholderPage = function ShareholderPage() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Ir/* Layout */.A, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
      color: "normal",
      titleText: "Interested in becoming an Investor?",
      subTitleText: "\u30C8\u30E9\u30A4\u30A2\u30EB\u306E\u682A\u4E3B\u306B\u306A\u308A\u307E\u305B\u3093\u304B"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 70,
        pc: 120
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* AHeading */.Os, {
        children: "\u682A\u4E3B\u306B\u306A\u308B\u30E1\u30EA\u30C3\u30C8"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* BHeading */.Zg, {
        children: "\u2460\u5F53\u793E\u306E\u7D4C\u55B6\u306B\u53C2\u52A0\u3067\u304D\u307E\u3059"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
        children: "\u682A\u4E3B\u306B\u306A\u308B\u3068\u3001\u4F1A\u793E\u306E\u6700\u9AD8\u610F\u601D\u6C7A\u5B9A\u6A5F\u95A2\u3067\u3042\u308B\u682A\u4E3B\u7DCF\u4F1A\u306B\u51FA\u5E2D\u3067\u304D\u3001\u8B70\u6C7A\u6A29\u306E\u884C\u4F7F\u3092\u901A\u3058\u3066\u3001\u5F53\u793E\u306E\u7D4C\u55B6\u306B\u53C2\u52A0\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 50,
          pc: 80
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* BHeading */.Zg, {
        children: "\u2461\u914D\u5F53\u91D1\u3092\u53D7\u3051\u53D6\u308C\u307E\u3059"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
        children: "\u682A\u4E3B\u306B\u306A\u308B\u3068\u3001\u914D\u5F53\u91D1\u3092\u53D7\u9818\u3059\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002\u5F53\u793E\u306F6\u6708\u6C7A\u7B97\u3067\u3042\u308A\u3001\u6BCE\u5E746\u6708\u672B\u304C\u914D\u5F53\u57FA\u6E96\u65E5\u3068\u306A\u308A\u307E\u3059\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
        children: "2027\u5E746\u6708\u671F\u306E\u671F\u672B\u914D\u5F53\u306F2027\u5E746\u670828\u65E5\uFF08\u795D\u65E5\u3001\u4F11\u65E5\u3092\u9664\u304F\u3001\u6A29\u5229\u78BA\u5B9A\u65E5\u304B\u3089\u8D77\u7B97\u3057\u30662\u55B6\u696D\u65E5\u524D\uFF09\u307E\u3067\u306B\u8A3C\u5238\u4F1A\u793E\u7B49\u3092\u901A\u3058\u3066\u3054\u8CFC\u5165\uFF08\u7D04\u5B9A\uFF09\u3044\u305F\u3060\u3044\u305F\u65B9\u304C\u5BFE\u8C61\u3068\u306A\u308A\u307E\u3059\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 20,
          pc: 50
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(DateTable, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 70,
          pc: 100
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* AHeading */.Os, {
        children: "\u682A\u4E3B\u306B\u306A\u308B\u306B\u306F"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(QuestionContent, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(QuestionIcon, {
          children: "Q"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(QuestionText, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "\u682A\u4E3B\u306B\u306A\u308B\u305F\u3081\u306E\u624B\u7D9A\u304D\u306F\u3001\u3069\u3053\u3067\u884C\u3048\u3070\u3044\u3044\u3067\u3059\u304B\uFF1F"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          pc: 20,
          sp: 16
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(AnswerContent, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(AnswerIcon, {
          children: "A"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(AnswerText, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "\u8A3C\u5238\u4F1A\u793E\u3092\u901A\u3058\u3066\u682A\u5F0F\u3092\u3054\u8CFC\u5165\u304F\u3060\u3055\u3044\u3002\u8CFC\u5165\u306B\u306F\u4E8B\u524D\u306B\u8A3C\u5238\u4F1A\u793E\u3067\u306E\u53E3\u5EA7\u958B\u8A2D\u304C\u5FC5\u8981\u306B\u306A\u308A\u307E\u3059\u3002\u8A73\u3057\u304F\u306F\u3001\u304A\u8FD1\u304F\u306E\u8A3C\u5238\u4F1A\u793E\u7A93\u53E3\u3084\u30A4\u30F3\u30BF\u30FC\u30CD\u30C3\u30C8\u53D6\u5F15\u3092\u884C\u3063\u3066\u3044\u308B\u8A3C\u5238\u4F1A\u793E\u306B\u3054\u76F8\u8AC7\u304F\u3060\u3055\u3044\u3002"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          pc: 44,
          sp: 20
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Line/* Line */.x, {
        color: "grey",
        weight: 1,
        direction: "horizon"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          pc: 44,
          sp: 20
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(QuestionContent, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(QuestionIcon, {
          children: "Q"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(QuestionText, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9\u306E\u682A\u5F0F\u306F\u3001\u3044\u304F\u3089\u304B\u3089\u8CFC\u5165\u3067\u304D\u307E\u3059\u304B\uFF1F"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          pc: 20,
          sp: 16
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(AnswerContent, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(AnswerIcon, {
          children: "A"
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(AnswerText, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "\u5F53\u793E\u306E\u682A\u5F0F\u306F\u3001100\u682A\u30921\u5358\u5143\u3068\u3057\u3066\u58F2\u8CB7\u3055\u308C\u3066\u3044\u307E\u3059\u3002"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "\u3064\u307E\u308A\u3001\u682A\u4FA1\xD7100\u682A\u306E\u91D1\u984D\u3067\u3001\u682A\u4E3B\u306B\u306A\u308B\u3053\u3068\u304C\u3067\u304D\u307E\u3059\u3002\u305F\u3060\u3057\u3001\u3054\u8CFC\u5165\u306E\u969B\u306B\u306F\u624B\u6570\u6599\u304C\u304B\u304B\u308A\u3001\u8A3C\u5238\u4F1A\u793E\u306B\u3088\u3063\u3066\u7570\u306A\u308A\u307E\u3059\u3002"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "\u203B\u3054\u6CE8\u610F\uFF1A\u682A\u4FA1\u306F\u5909\u52D5\u3057\u307E\u3059\u306E\u3067\u8CFC\u5165\u306E\u969B\u306F\u6700\u65B0\u306E\u682A\u4FA1\u3092\u3054\u81EA\u8EAB\u3067\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u307E\u3059\u3088\u3046\u304A\u9858\u3044\u3044\u305F\u3057\u307E\u3059\u3002"
          })]
        })]
      })]
    })]
  });
};

ShareholderPage.getLayout = function (page) {
  var breadCrumbs = [{
    name: 'ホーム',
    path: '/'
  }, {
    name: '株主・投資家向け情報',
    path: '/ir/'
  }, {
    name: '個人投資家の皆様へ',
    path: '/ir/investor/'
  }, {
    name: 'トライアルの株主になりませんか',
    path: ''
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Head/* Head */.F, {
      title: "\u30C8\u30E9\u30A4\u30A2\u30EB\u306E\u682A\u4E3B\u306B\u306A\u308A\u307E\u305B\u3093\u304B",
      description: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9\u306E\u682A\u4E3B\u3078\u306E\u3054\u6848\u5185\u3092\u63B2\u8F09\u3057\u3066\u3044\u307E\u3059\u3002",
      ogp: {
        url: 'ir/investor/shareholder/'
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(layout/* TitleLayout */.$0, {
      title: "Investor Relations",
      subTitle: "\u682A\u4E3B\u30FB\u6295\u8CC7\u5BB6\u5411\u3051\u60C5\u5831",
      breadCrumbs: breadCrumbs,
      children: page
    })]
  });
};

var QuestionContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Shareholder__QuestionContent",
  componentId: "sc-18wrekh-0"
})(["display:flex;gap:10px;"]);
var QuestionIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Shareholder__QuestionIcon",
  componentId: "sc-18wrekh-1"
})(["background:", ";color:white;font-family:'Rubik';font-style:normal;font-size:18px;line-height:1;display:flex;justify-content:center;align-items:center;width:30px;height:30px;border-radius:20px;padding:6px 8.5px;"], theme/* theme.colors.trialBlue */.r.colors.trialBlue);
var QuestionText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Shareholder__QuestionText",
  componentId: "sc-18wrekh-2"
})(["p{font-size:18px;line-height:1.5;color:#002d65;font-weight:700;}@media screen and (max-width:1047px){p{font-size:16px;}}"]);
var AnswerContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Shareholder__AnswerContent",
  componentId: "sc-18wrekh-3"
})(["display:flex;gap:10px;"]);
var AnswerIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Shareholder__AnswerIcon",
  componentId: "sc-18wrekh-4"
})(["background:", ";color:white;font-family:'Rubik';font-style:normal;font-size:18px;line-height:1;display:flex;justify-content:center;align-items:center;width:30px;height:30px;border-radius:20px;padding:6px 8.5px;"], theme/* theme.colors.grey */.r.colors.grey);
var AnswerText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Shareholder__AnswerText",
  componentId: "sc-18wrekh-5"
})(["p{font-size:16px;line-height:1.8;}@media screen and (max-width:1047px){p{font-size:15px;}}"]);
;// CONCATENATED MODULE: ./src/pages/ir/investor/shareholder.tsx


/***/ }),

/***/ 23717:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ir/investor/shareholder",
      function () {
        return __webpack_require__(54181);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,3874,2768,5548,4535,9774,2888,179], function() { return __webpack_exec__(23717); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);